import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    todayCustomerStat: {
        url: `${customerApi}/api/customer_stat/today`,
        type: 'GET',
    },
    todayChannelRank: {
        url: `${customerApi}/api/customer_stat/channel_ranking/today`,
        type: 'GET',
    },
    customerStat: {
        url: `${customerApi}/api/customer_stat/by_date`,
        type: 'GET',
    },
    customerChannels: {
        url: `${customerApi}/api/customer_distribution/by_channel`,
        type: 'GET',
    },
    lostCustomers: {
        url: `${customerApi}/api/lost_customers/stat`,
        type: 'POST',
    },
}
